document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-hollora-sticky]');
  var anchor = document.querySelector('[data-hollora-actions]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { rootMargin: '0px' }
    ).observe(anchor);

    var stickyBtn = bar.querySelector('[data-hollora-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var main = document.querySelector('[data-hollora-add]');
        if (main) main.click();
      });
    }
    document.addEventListener('hollora:variant', function (e) {
      var priceOut = bar.querySelector('[data-hollora-sticky-price]');
      if (priceOut && e.detail && e.detail.variant) priceOut.innerHTML = e.detail.variant.price;
    });
  }

  var videos = document.querySelectorAll('[data-hollora-video] video');
  if (videos.length && 'IntersectionObserver' in window) {
    var vo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.4 }
    );
    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      vo.observe(v);
    });
  }
});
